import { Component, contentChild, effect, HostBinding, input, ChangeDetectionStrategy } from '@angular/core'
import { MatCard } from '@angular/material/card'

export type InfoCardAppearance = 'info' | 'ok' | 'error' | 'warn' | 'neutral'

/**
 * Expects a <mat-card> ... </mat-card>
 */
@Component({
  selector: 'lib-info-card',
  template: `<ng-content></ng-content>`,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @use '@angular/material' as mat;

    :host {
      display: block;
    }

    :host.info {
      @include mat.card-overrides(
        (
          outlined-container-color: light-dark(#dcedec, #1a2b2b),
        )
      );
    }

    /*
      Erfolgs-Variante: „ist so, wie es sein soll" — z. B. eine Import-Vorschau ohne Abweichung.
      Sie nimmt bewusst das Status-Trio aus basic.scss (und nicht wie .warn eigene Hex-Werte), damit
      dieselbe Aussage hier und im lib-status-chip denselben Ton hat.
    */
    :host.ok {
      @include mat.card-overrides(
        (
          outlined-container-color: var(--lib-ok-surface),
          outlined-outline-color: var(--lib-ok-accent),
          outlined-outline-width: 1px,
        )
      );
      color: var(--lib-on-ok-surface);
    }

    :host.warn {
      @include mat.card-overrides(
        (
          outlined-container-color: #fefce8,
          outlined-outline-color: #eab308,
          outlined-outline-width: 1px,
        )
      );
      color: #854d0e;
    }

    :host.error {
      @include mat.card-overrides(
        (
          outlined-container-color: var(--mat-sys-error-container),
        )
      );
    }
  `,
})
export class InfoCardComponent {
  readonly card = contentChild.required(MatCard)
  readonly appearance = input<InfoCardAppearance>('info')

  private readonly applyStyle = effect(() => {
    this.card().appearance = 'outlined'
  })

  @HostBinding('class')
  get appearanceClass() {
    return this.appearance()
  }
}
